/* Extracted from snippets/cookie-consent.liquid (lines 235-607 of the 20 Oct 2026 live copy) by checks/split_inline_js.py.
   Same code, same position in the page; now a cached asset instead of inline HTML. */
  (function () {
    'use strict';

    var COOKIE_NAME = 'tc_cookie_consent';
    var COOKIE_DAYS = 365;
    var banner = document.querySelector('[data-cookie-consent]');
    var acceptBtn = document.querySelector('[data-cookie-accept]');
    var rejectBtn = document.querySelector('[data-cookie-reject]');

    if (!banner) return;

    function getCookie(name) {
      var escapedName = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      var match = document.cookie.match(new RegExp('(?:^|; )' + escapedName + '=([^;]*)'));
      return match ? decodeURIComponent(match[1]) : null;
    }

    function setCookie(name, value, days) {
      var expires = new Date(Date.now() + days * 864e5).toUTCString();
      document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/; SameSite=Lax; Secure';
    }

    function expireCookie(name) {
      document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Lax; Secure';
    }

    // Analytics / advertising cookies set under an earlier Accept (Google
    // Analytics + Ads, Meta, TikTok, Microsoft, Pinterest, Clarity, Shopify's
    // own analytics/marketing, Rivo's baMet_/baMsg_ visit and cart tracking). Shopify's
    // _tracking_consent, cart, session and preview cookies are never touched.
    var TRACKING_COOKIE = /^(_ga($|_)|_gid$|_gat|_gcl_|_fbp$|_fbc$|_ttp$|_tt_enable_cookie$|ttcsid|_uet|_pin_unauth$|_pinterest_|_clck$|_clsk$|_shopify_sa_|_shopify_y$|_shopify_s$|baMet_|baMsg_|ba_cart_token$|ba_conversion)/;

    // Rivo also keeps visitor IDs and cart data in localStorage.
    var TRACKING_STORAGE = /^(baMet_|baMsg_|ba_conversion)/;

    function clearTrackingStorage() {
      try {
        for (var i = localStorage.length - 1; i >= 0; i--) {
          var k = localStorage.key(i);
          if (k && TRACKING_STORAGE.test(k)) localStorage.removeItem(k);
        }
      } catch (e) { /* storage blocked */ }
    }

    function expireTrackingCookies() {
      clearTrackingStorage();
      var names = document.cookie.split(';').map(function (c) { return c.split('=')[0].trim(); })
        .filter(function (n) { return n && TRACKING_COOKIE.test(n); });
      if (!names.length) return;
      // Tags set them on the registrable domain (".thecolor.uk") or host-only:
      // clear every parent-domain variant plus the host-only one.
      var parts = location.hostname.split('.');
      var domains = [''];
      for (var i = 0; i < parts.length - 1; i++) domains.push('; domain=.' + parts.slice(i).join('.'));
      names.forEach(function (n) {
        domains.forEach(function (d) {
          document.cookie = n + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; max-age=0; path=/' + d;
        });
      });
    }

    function updateGtagConsent(state) {
      if (typeof gtag !== 'function') return;
      gtag('consent', 'update', {
        analytics_storage: state,
        ad_storage: state,
        ad_user_data: state,
        ad_personalization: state
      });
    }

    
    var pendingConsent = null;
    var apiRequested = false;
    var hooksBound = false;
    var lastIntended = null;      // the latest choice sent to Shopify
    var lastOwnCallAt = 0;        // when this script last called setTrackingConsent
    var choiceSeq = 0;            // bumps on every new choice (not on re-asserts)
    var reassertedSeq = -1;       // the choice already re-asserted once
    var OWN_ECHO_MS = 5000;       // events this soon after our own call are echoes of it
    var onShopifySettled = [];    // callbacks waiting for Shopify to confirm it

    // true / false once the API can answer; null when it can't tell.
    function shopifyConsentMatches(granted) {
      try {
        var cp = window.Shopify && window.Shopify.customerPrivacy;
        if (!cp || typeof cp.currentVisitorConsent !== 'function') return null;
        var c = cp.currentVisitorConsent() || {};
        var want = granted ? 'yes' : 'no';
        return c.marketing === want && c.analytics === want;
      } catch (e) { return null; }
    }

    function settleShopify(granted) {
      var queue = onShopifySettled;
      onShopifySettled = [];
      queue.forEach(function (fn) { try { fn(granted); } catch (e) { /* ignore */ } });
    }

    function applyShopifyConsent(granted, isRetry) {
      if (!window.Shopify || !window.Shopify.customerPrivacy ||
          typeof window.Shopify.customerPrivacy.setTrackingConsent !== 'function') return false;
      lastIntended = granted;
      lastOwnCallAt = Date.now();
      try {
        window.Shopify.customerPrivacy.setTrackingConsent(
          {
            analytics: granted,
            marketing: granted,
            preferences: granted,
            sale_of_data: granted
          },
          function () {
            // A newer choice has been sent since — that call verifies itself.
            if (granted !== lastIntended) return;
            // Re-read what Shopify actually stored. An older request still in
            // flight (e.g. the page-load "yes" for a returning visitor) can
            // land after this one; retry once if the state didn't take.
            if (shopifyConsentMatches(granted) === false && !isRetry) {
              setTimeout(function () {
                if (granted === lastIntended && !applyShopifyConsent(granted, true)) settleShopify(granted);
              }, 300);
              return;
            }
            settleShopify(granted);
          }
        );
        return true;
      } catch (e) { return false; }
    }

    function flushPendingConsent() {
      if (pendingConsent === null) return;
      if (applyShopifyConsent(pendingConsent)) pendingConsent = null;
    }

    function requestConsentApi() {
      if (!hooksBound) {
        hooksBound = true;
        document.addEventListener('shopify_customer_privacy_api_loaded', flushPendingConsent);
        document.addEventListener('DOMContentLoaded', function () { requestConsentApi(); flushPendingConsent(); });
        window.addEventListener('load', function () { requestConsentApi(); flushPendingConsent(); });
      }
      if (apiRequested) return;
      if (window.Shopify && window.Shopify.customerPrivacy) { apiRequested = true; return; }
      if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;
      apiRequested = true;
      try {
        window.Shopify.loadFeatures(
          [{ name: 'consent-tracking-api', version: '0.1' }],
          function (error) { if (!error) flushPendingConsent(); }
        );
      } catch (e) { apiRequested = false; }
    }

    function syncShopifyConsent(granted) {
      choiceSeq++;
      pendingConsent = granted;
      flushPendingConsent();
      if (pendingConsent !== null) requestConsentApi();
    }

    // Load the Consent Tracking API on every page, then apply the stored
    // choice (theme cookie is the source of truth for returning visitors).
    requestConsentApi();
    var existingConsent = getCookie(COOKIE_NAME);

    // Our own testing (internal visitor): ?tc_internal=1 sets tc_internal for
    // a year, ?tc_internal=0 clears it. While set, the visit counts as a
    // Reject (Shopify tracking consent "no", so no pixel fires) and the
    // banner stays hidden; the theme's own consent cookie is left alone.
    var internalFlag = (location.search.match(/[?&]tc_internal=([01])(?:&|$)/) || [])[1];
    if (internalFlag === '1') setCookie('tc_internal', '1', 365);
    else if (internalFlag === '0') expireCookie('tc_internal');
    if (getCookie('tc_internal') === '1') {
      existingConsent = 'rejected';
      banner.style.display = 'none';
      updateGtagConsent('denied');
    }
    if (existingConsent === 'accepted') {
      syncShopifyConsent(true);
    } else if (existingConsent === 'rejected') {
      syncShopifyConsent(false);
    }

    // hadGranted: tags may already have run under an Accept on this page (or
    // a stored one) — a later Reject is then a withdrawal (reload + clear).
    var hadGranted = existingConsent === 'accepted';

    // App embeds (Rivo's baMet_ visit counters) set analytics cookies without
    // waiting for consent. Until the visitor accepts, clear them once the
    // page has loaded and again after late app scripts have run.
    if (existingConsent !== 'accepted') {
      var clearUnconsented = function () {
        if (getCookie(COOKIE_NAME) !== 'accepted') expireTrackingCookies();
      };
      var afterLoad = function () {
        clearUnconsented();
        setTimeout(clearUnconsented, 4000);
      };
      if (document.readyState === 'complete') afterLoad();
      else window.addEventListener('load', afterLoad);
    }

    // Bi-directional sync: if another integration (a Shopify-managed banner,
    // an app, a CMP) collects consent through the customerPrivacy API
    // directly, mirror it into the theme cookie — grants AND revocations — so
    // the theme's own gtag gates stay in step.
    //
    // Events within 5 s of this script's own setTrackingConsent call are the
    // ECHOES of those calls, not someone else's choice, and are never
    // mirrored: an older request still in flight (e.g. the page-load "yes",
    // or the "no" sent by Cookie settings just before Accept) can land after
    // the visitor's newest choice. If an echo disagrees with that choice,
    // the choice is re-sent once.
    document.addEventListener('visitorConsentCollected', function (event) {
      try {
        var d = event && event.detail || {};
        // Shopify normalises consent values to booleans or "yes" / "no".
        var isYes = function (v) { return v === true || v === 'yes'; };
        var isNo = function (v) { return v === false || v === 'no'; };
        var evtYes = isYes(d.marketingAllowed) && isYes(d.analyticsAllowed);
        var evtNo = isNo(d.marketingAllowed) || isNo(d.analyticsAllowed);
        if (lastIntended !== null && Date.now() - lastOwnCallAt < OWN_ECHO_MS) {
          var disagrees = (evtYes && lastIntended === false) || (evtNo && lastIntended === true);
          if (disagrees && reassertedSeq !== choiceSeq) {
            reassertedSeq = choiceSeq;
            pendingConsent = lastIntended;
            flushPendingConsent();
          }
          return;
        }
        var current = getCookie(COOKIE_NAME);
        if (evtYes) {
          if (current !== 'accepted') {
            hadGranted = true;
            setCookie(COOKIE_NAME, 'accepted', COOKIE_DAYS);
            updateGtagConsent('granted');
            try { document.dispatchEvent(new CustomEvent('tc:consent-granted')); } catch (e) { /* ignore */ }
          }
        } else if (evtNo && current === 'accepted') {
          setCookie(COOKIE_NAME, 'rejected', COOKIE_DAYS);
          updateGtagConsent('denied');
          try { document.dispatchEvent(new CustomEvent('tc:consent-withdrawn')); } catch (e) { /* ignore */ }
        }
      } catch (e) { /* ignore */ }
    });

    // Diagnostic logger — append ?_tcdebug=tracking to any URL.
    if (/[?&]_tcdebug=tracking/.test(location.search)) {
      setTimeout(function () {
        var cp = window.Shopify && window.Shopify.customerPrivacy;
        var googleScripts = Array.from(document.querySelectorAll('script[src*="googletagmanager.com/gtag/js"]'))
          .map(function (s) { return s.src.split('?id=')[1] || s.src; });
        console.group('[The Color] Tracking diagnostic');
        console.log('Theme cookie:', getCookie(COOKIE_NAME) || '(not set)');
        if (cp) {
          console.log('Shopify userCanBeTracked:', cp.userCanBeTracked());
          console.log('Shopify marketingAllowed:', cp.marketingAllowed());
          console.log('Shopify currentVisitorConsent:', cp.currentVisitorConsent());
        } else {
          console.warn('Shopify.customerPrivacy not loaded yet');
        }
        console.log('gtag.js loaded for:', googleScripts.length ? googleScripts.join(', ') : '(none)');
        console.log('dataLayer entries:', (window.dataLayer || []).length);
        console.groupEnd();
      }, 1500);
    }

    var hideTimer = null;
    // The "Cookie settings" control that re-opened the banner, if any.
    // Focus goes back to it after the visitor chooses (WCAG 2.4.3) instead
    // of falling to <body> at the bottom of the page.
    var reopenTrigger = null;

    function showBanner() {
      if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; }
      banner.style.display = '';
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          banner.classList.add('is-visible');
          // Move screen-reader/keyboard focus to the banner (tabindex="-1")
          // so assistive tech announces it without aria-live spam.
          try { banner.focus({ preventScroll: true }); } catch (e) { /* ignore */ }
        });
      });
    }

    function dismissBanner(value) {
      setCookie(COOKIE_NAME, value, COOKIE_DAYS);
      banner.classList.remove('is-visible');
      hideTimer = setTimeout(function () {
        banner.style.display = 'none';
        hideTimer = null;
      }, 400);
      if (reopenTrigger) {
        try { reopenTrigger.focus({ preventScroll: true }); } catch (e) { /* ignore */ }
        reopenTrigger = null;
      }
      // Generic "a consent choice was made" signal — fired for BOTH accept
      // and reject. The welcome popup waits on this so the two never stack.
      try { document.dispatchEvent(new CustomEvent('tc:consent-decided', { detail: { value: value } })); } catch (e) { /* ignore */ }
    }

    // Final step of a withdrawal (Reject after an earlier Accept): clear the
    // cookies the tags already set, then reload once Shopify confirms "no"
    // (or after 2.5 s at most), so nothing loaded under the old consent keeps
    // running on this page.
    var reloadQueued = false;
    function completeWithdrawal() {
      if (reloadQueued) return;
      reloadQueued = true;
      expireTrackingCookies();
      var go = function () {
        expireTrackingCookies();
        try { window.location.reload(); } catch (e) { /* ignore */ }
      };
      var timer = setTimeout(go, 2500);
      onShopifySettled.push(function (granted) {
        if (granted !== false) return;
        clearTimeout(timer);
        setTimeout(go, 150);
      });
    }

    // Accept handler
    if (acceptBtn) {
      acceptBtn.addEventListener('click', function () {
        hadGranted = true;
        dismissBanner('accepted');
        updateGtagConsent('granted');
        // Tell Shopify's Web Pixels Manager — this is what unblocks the
        // marketing pixels for this visitor.
        syncShopifyConsent(true);
        // Page-scoped subscribers (product.js view_item, etc.) fire their
        // events for the current page once consent arrives.
        try { document.dispatchEvent(new CustomEvent('tc:consent-granted')); } catch (e) { /* ignore */ }
      });
    }

    // Reject handler (necessary cookies only)
    if (rejectBtn) {
      rejectBtn.addEventListener('click', function () {
        var withdrawing = hadGranted;
        dismissBanner('rejected');
        updateGtagConsent('denied');
        // Accepted on this page (or arrived accepted): clear + reload.
        // Otherwise still clear what an earlier Accept left behind — e.g.
        // Cookie settings on one page, then Reject on the next one.
        if (withdrawing) completeWithdrawal();
        else expireTrackingCookies();
        syncShopifyConsent(false);
      });
    }

    // Withdraw / change consent — "Cookie settings" (footer) or any other
    // [data-cookie-settings] trigger. Delegated, and bound BEFORE the early
    // return below, so it works for visitors who have already decided.
    document.addEventListener('click', function (e) {
      var trigger = e.target && e.target.closest ? e.target.closest('[data-cookie-settings]') : null;
      if (!trigger) return;
      e.preventDefault();
      reopenTrigger = trigger;
      expireCookie(COOKIE_NAME);
      syncShopifyConsent(false);
      updateGtagConsent('denied');
      try { document.dispatchEvent(new CustomEvent('tc:consent-withdrawn')); } catch (err) { /* ignore */ }
      showBanner();
    });

    // Early return for already-decided visitors (banner stays hidden)
    if (existingConsent === 'accepted' || existingConsent === 'rejected') return;

    showBanner();
  })();
